var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleLeft = function SvgAngleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 19.256a.76.76 0 0 0-.204-.506l-6.189-6.752 6.189-6.75a.7.7 0 0 0 .149-.239.78.78 0 0 0-.061-.688.7.7 0 0 0-.302-.268.6.6 0 0 0-.387-.038c-.13.03-.249.101-.341.205l-6.659 7.265a.76.76 0 0 0-.195.513c0 .193.07.378.195.514l6.659 7.265a.65.65 0 0 0 .344.208c.132.03.268.015.392-.04a.7.7 0 0 0 .303-.276.8.8 0 0 0 .107-.413"
  })));
};
export { SvgAngleLeft as ReactComponent };